import { AuditEntity } from './AuditEntity';
import { FoodItem } from './FoodItem';
import { FoodTray } from './FoodTrayTemplate';

export interface FoodType extends AuditEntity {
  ocisId: string;
  isActive: boolean;
  maxHoldTime: string;
  foodTrays?: FoodTray[];
  overrideFoodItems?: FoodItem[];
  translatedLabels: TranslatedLabel[];
}

export enum FoodTypeField {
  NAME = 'name',
  MAX_HOLD_TIME = 'maxHoldTime',
  ARTICLE_NUMBER = 'articleNumber',
  IS_ACTIVE = 'isActive',
  OCIS_ID = 'ocisId',
}

interface TranslatedLabel {
  translation: string;
  languageCode: string;
}
